"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var iosAlbumsOutline = exports.iosAlbumsOutline = { "viewBox": "0 0 512 512", "children": [{ "name": "g", "attribs": {}, "children": [{ "name": "path", "attribs": { "d": "M464,144v288H48V144H464 M480,128H32v320h448V128L480,128z" }, "children": [{ "name": "path", "attribs": { "d": "M464,144v288H48V144H464 M480,128H32v320h448V128L480,128z" }, "children": [] }] }, { "name": "rect", "attribs": { "x": "72", "y": "96", "width": "368", "height": "16" }, "children": [{ "name": "rect", "attribs": { "x": "72", "y": "96", "width": "368", "height": "16" }, "children": [] }] }, { "name": "rect", "attribs": { "x": "104", "y": "64", "width": "304", "height": "16" }, "children": [{ "name": "rect", "attribs": { "x": "104", "y": "64", "width": "304", "height": "16" }, "children": [] }] }] }] };


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-icons-kit/ionicons/iosAlbumsOutline.js
// module id = 939
// module chunks = 1